var map = {
	"./icons/colorfill.png": "0e71",
	"./icons/eraser.png": "8159",
	"./icons/paintbrush.png": "4d20",
	"./icons/pencil.png": "cb86",
	"./icons/sticker.png": "50b3",
	"./icons/strokebrush.png": "cd85",
	"./logo.png": "cf05",
	"./references/dogin.jpg": "8e65",
	"./references/image1-reference.jpg": "d5df",
	"./references/image1.jpg": "56d0",
	"./references/image2-reference.jpg": "a8b3",
	"./references/image2.jpg": "96cb",
	"./references/image3-reference.jpg": "b943",
	"./references/image3.jpg": "6d8f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";